

import { Component, Watch, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";

import IbHeader from "../components/Header/Header.vue";
import IbAside from "../components/IBAside/IBAside.vue";

import IbDropdown from "@/components/Dropdown/Dropdown.vue";
import NotificationPanel from "@/components/Notification/Notification-panel.vue";

import { MODAL_MODULE_NAME } from "@/store/modules/modal";
import { LOADING_MODULE_NAME } from "@/store/modules/loading";
import { PROFILE_MODULE_NAME } from "@/store/modules/profile";
import { AUTH_MODULE_NAME } from "@/store/modules/auth";
import { IProfileEntity } from "@/models/modules/profile/interface";
import IBDropdownClose from "@/components/Dropdown/IBDropdownClose";
import { APP_MODULE_NAME } from "@/store/modules/app";
import EventEmitter from "@/modules/Event/EventEmitter";
import { EventEmitterName } from "@/modules/Event/interface";

@Component({
	components: {
		NotificationPanel,
		IbDropdown,
		IbAside,
		IbHeader
	}
})
export default class MainLayout extends Mixins(IBDropdownClose) {

	@Getter('contentKey', { namespace: APP_MODULE_NAME })
	contentKey!: number

	public asideMenus: Object;

	public historyChipsBtn: string;

	public chipsGroup: any[];
	public btnItems: any[];

	public isModal: boolean = false;
	public isModalHide: boolean = false;
	public isModalChips: boolean = false;

	appKey: number = 1;

	constructor() {
		super();

		this.historyChipsBtn = "";

		this.asideMenus = {
			headerList: [
				{
					imgUrl: "/img/icons/header-mobile/home-icon-primary.svg",
					text: this.$t("header.main"),
					urlRoute: "/",
					isActive: false
				},
				{
					imgUrl: "/img/icons/header-mobile/briefcase-icon-primary.svg",
					text: this.$t("header.services"),
					urlRoute: "/services",
					isActive: false
				},
				{
					imgUrl: "/img/icons/header-mobile/clock-icon-primary.svg",
					text: this.$t("header.history"),
					urlRoute: "/transactions-history",
					isActive: false
				}
				/*{
					imgUrl: '/img/icons/header-mobile/clock-icon-primary.svg',
					text: this.$t("header.electCommerce"),
					urlRoute: '/electronic-commerce',
					isActive: false
				}*/
			],
			list: [
				{
					imgUrl: "/img/icons/file-exclamation.svg",
					text: this.$t("menu.terms"),
					urlRoute: "/plans",
					isActive: false
				},
				{
					imgUrl: "/img/icons/users.svg",
					text: this.$t("menu.employees"),
					urlRoute: "/employees",
					isActive: false
				},
				{
					imgUrl: "/img/icons/calculator.svg",
					text: this.$t("menu.branch"),
					isActive: false
				},
				{
					imgUrl: "/img/icons/graph-plus.svg",
					text: this.$t("menu.current"),
					urlRoute: "/exchange-rates",
					isActive: false
				},
				{
					imgUrl: "/img/icons/users-group.svg",
					text: this.$t("menu.contract"),
					urlRoute: "/counterparties",
					isActive: false
				},
				{
					imgUrl: "/img/icons/lifebuoy.svg",
					text: this.$t("menu.support"),
					urlRoute: "/support",
					isActive: false
				}
			],
			sublist: [
				{
					imgUrl: "/img/icons/settings.svg",
					text: this.$t("menu.setting"),
					urlRoute: "/settings",
					isActive: false
				}
			]
		};
		this.chipsGroup = [
			{
				title: this.$t("transactHistory.format"),
				chipsBtn: [
					{
						title: "TXT",
						dropdown: false
					},
					{
						title: "PDF",
						dropdown: false
					},
					{
						title: "XLS",
						dropdown: false
					}
				]
			},
			{
				title: this.$t("transactHistory.period"),
				chipsBtn: [
					{
						title: this.$t("transactHistory.year"),
						dropdown: false
					},
					{
						title: this.$t("transactHistory.month"),
						dropdown: false
					},
					{
						title: this.$t("transactHistory.week"),
						dropdown: false
					}
				]
			}
		];
		this.btnItems = [
			{
				name: this.$t("transactHistory.upload"),
				class: "btn-primary"
			}
		];
	}

	@Getter("isActive", { namespace: LOADING_MODULE_NAME })
	loadingIsActive!: boolean;

	@Getter("profile", { namespace: PROFILE_MODULE_NAME })
	profile!: IProfileEntity;

	@Getter("isAuth", { namespace: AUTH_MODULE_NAME })
	isAuth!: boolean;

	@Watch("profile")
	omLangChanged() {
		this.appKey++;
	}

	@Watch("$route")
	removeSessionLocal() {
		if (sessionStorage.getItem("swift")) {
			if (this.$route.name !== "SendingSwiftContent" && this.$route.name !== "SendingSwiftContentPath") {
				sessionStorage.removeItem("swift");
			}
		}
		if (sessionStorage.getItem("sumPayment")) {
			if (this.$route.name !== "CreateSumPayment-content") {
				sessionStorage.removeItem("sumPayment");
			}
		}
	}

	created() {
		EventEmitter.addListener(EventEmitterName.OPEN_NOTIFICATION, () =>
			this.openNotification());
	}

	openNotification() {
		this.isActiveModal = !this.isActiveModal;
	}

	openModalMain() {
		this.isModal = !this.isModal;
	}

	openModalHide() {
		this.isModalHide = !this.isModalHide;
	}

	openModalChips() {
		this.isModalChips = !this.isModalChips;
	}

	onClickBtn(e: string) {
		this.historyChipsBtn = e;
	}

	mounted() {
		if (this.$store.getters[`${MODAL_MODULE_NAME}/modalOpen`]) {
			this.openModalChips();
		}
	}
}

